.profileCard {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;

  .profileCardImageWrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }

  .VerifiedIcon {
    margin-left: 8px;
    display: flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .profileCardUserName {
    display: flex;
    margin-top: 0;
  }

  .userName {
    font: var(--font-body-md-medium);
    line-height: 25px;
    color: var(--primitives-colors-neutral-0);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 220px;

    .phone &,
    .tablet & {
      max-width: 150px;
    }
  }

  .profileCardFollowers {
    text-transform: uppercase;
    font: var(--font-body-sm-regular);
    line-height: 22px;
    color: var(--semantic-colors-typography-faded);
    text-decoration: none;
    width: 100%;
    margin-top: 2px;
    white-space: nowrap;
  }

  .profileCardFollowBtnWrap {
    flex: 1 0 auto;
    display: flex;
    justify-content: flex-end;
  }
}